<template>
    <rkm-form ref="Form">

        <rkm-area type="fieldset" title="Medicamentos">

            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-model="data.medicamentoSupervisor.dispensar"
                    >
                        Dispensar medicamentos, antes da próxima data de retirada, somente com a utilização
                        da senha do supervisor.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area type="fieldset" title="Posologia">

            <rkm-row>
                <rkm-col>
                    <rkm-form-checkbox
                        v-model="data.posologia.isObrigatorio"
                    >
                        A posologia é obrigatória. O campo "prescrito" será automaticamente preenchido com base nas
                        informações da posologia, sendo impossível modificá-lo. O campo "entregue" estará disponível somente
                        após o preenchimento das informações da posologia.
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.prazoReceitaDias"
                    label="Prazo de dias da receita"
                    number
                    v-model="data.dispensacao.prazoReceitaDias"
                />
            </rkm-col>
        </rkm-row>

        <rkm-area type="fieldset" title="Limite de Prescrição">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        v-model="data.limitePrescricaoMedicamento.limiteDias"
                        label="Limite em dias aceito para a validade da receita. Se não informado, o padrão preenchido são de 180 dias."
                />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                prazoReceitaDias: { max: 3 },
            }
        }
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        }
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        'data.limitePrescricaoMedicamento.limiteDias': {
            deep: true,
            handler(value) {
                if(value > 180){
                    this.data.limitePrescricaoMedicamento.limiteDias = 180;
                }
                if(value < 0){
                    this.data.limitePrescricaoMedicamento.limiteDias = 1;
                }
            }
        }
    }
}
</script>